import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { Pencil } from "lucide-react";
import NoteDeFraisForm from "@/features/rh/notes-de-frais/components/NoteDeFraisForm";

export const Route = createFileRoute("/_app/rh/notes-de-frais/$id/edit")({
  loader: requirePermission(PERMISSIONS.RH.FRAIS.EDIT),
  staticData: {
    title: "Modifier une note de frais",
    icon: Pencil,
    permission: PERMISSIONS.RH.FRAIS.EDIT,
    section: "Ressources Humaines",
    showInBreadcrumb: true,
  },
  component: () => {
    const { id } = useParams({ from: "/_app/rh/notes-de-frais/$id/edit" });
    return <NoteDeFraisForm backTo="/rh/notes-de-frais" editMode noteId={id} />;
  },
});
